import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import shape1 from "../../../Assets/Images/Shape 1.webp";
import shape2 from "../../../Assets/Images/Shape 2.webp";
import shape3 from "../../../Assets/Images/shapeFive.webp";
import shape4 from "../../../Assets/Images/Shape six.webp";
import shape5 from "../../../Assets/Images/ShapeSeven.webp";
import wrapperIcon from "../../../Assets/Images/Icon Wrapper.webp";

import "../AskedQuestion/NewAskedQuestion.css";
import "../Technology/AllBanner/DatabaseBanner.css";
import "../OurTechAndFram/OurTechAndFrame.css";
import { Link } from "react-router-dom";

const industries = [
  {
    id: 1,
    title: "Professional Services",
    desc: "We design and implement the systems that support client work, internal collaboration, reporting, and development. Nothing more. Nothing less.",
    icon: "https://i.ibb.co.com/p6QSD6ky/icon-1.png",
  },
  {
    id: 2,
    title: "Telecommunications",
    desc: "Our solutions manage communication flows, user information, billing calculations, and reliability in the fast-moving, high-volume world.",
    icon: "https://i.ibb.co.com/d4Mc6Xhb/icon-2.png",
  },
  {
    id: 3,
    title: "Social Media",
    desc: "Our products are made for engagement, moderation challenges, scalability, and shifting user behavior.",
    icon: "https://i.ibb.co.com/67DWf8tv/icon-3.png",
  },
  {
    id: 4,
    title: "Payments",
    desc: "Secure payment systems built around trust, compliance, integrations, and smooth transaction experiences that users barely notice.",
    icon: "https://i.ibb.co.com/8DcX3SDZ/icon-4.png",
  },
  {
    id: 5,
    title: "Hotel Management",
    desc: "Software to simplify bookings, operations, management of staff and services, and guest experience for the daily running of a hotel.",
    icon: "https://i.ibb.co.com/wht5GbQ2/icon-5.png",
  },
  {
    id: 6,
    title: "E-Commerce",
    desc: "eCommerce solutions that provide for speed, ease of use, integration, inventory logic, and sustainable long-term growth.",
    icon: "https://i.ibb.co.com/ZRSWDNgg/icon-6.png",
  },
  {
    id: 7,
    title: "Insurance",
    desc: "Process-driven solutions that assist in handling policies, claims, accuracy of data, and communication with customers.",
    icon: "https://i.ibb.co.com/gbzz8rXM/icon-7.png",
  },
  {
    id: 8,
    title: "Healthcare",
    desc: "Systems designed with privacy, reliability, and workflow clarity at the centre of patient and provider interactions.",
    icon: "https://i.ibb.co.com/Kxqc9zDk/icon-8.png",
  },
  {
    id: 9,
    title: "Food Delivery",
    desc: "A fully connected end-to-end solution linking restaurants, riders, and customers through ordering and real-time tracking.",
    icon: "https://i.ibb.co.com/MkTZ9PGm/icon-9.png",
  },
  {
    id: 10,
    title: "Education",
    desc: "Platforms designed to facilitate learning content distribution, tracking, management, and the latest in education paradigm shifts.",
    icon: "https://i.ibb.co.com/p63PmFJ4/icon-10.png",
  },
  {
    id: 11,
    title: "POS System",
    desc: "Trustworthy transaction systems that will help with inventory management and business reporting in multiple locations.",
    icon: "https://i.ibb.co.com/B5GYR1jw/icon-11.png",
  },
  {
    id: 12,
    title: "Banking",
    desc: "Secure and scalable platforms that serve the purpose of compliance as well as transactions.",
    icon: "https://i.ibb.co.com/Nz6FgLH/icon-12.png",
  },
];

const IndustriesWeWork = () => {
  const [hovered, setHovered] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const parentVariants = {
    rest: { scale: 1, boxShadow: "0 1px 4px rgba(100, 95, 95, 0.05)", y: 0 },
    hover: {
      scale: 1.02,
      boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
      y: -8,
      transition: { type: "tween", duration: 0.5, ease: "easeOut" },
    },
  };

  const childVariants = {
    rest: {},
    hover: { transition: { staggerChildren: 0.04 } },
  };

  const childItemVariants = {
    rest: { y: 0, opacity: 1 },
    hover: {
      y: -8,
      opacity: 1,
      transition: { duration: 0.18, ease: "easeOut" },
    },
  };

  const visibleIndustries =
    isMobile && !showAll ? industries.slice(0, 7) : industries;

  return (
    <div id="industries">
      {/* =================== INDUSTRIES SECTION =================== */}
      <section
        className="ind-padding border-bottom px-5 bg-light"
        style={{
          position: "relative",
          overflow: "visible",
          borderBottom: "1px solid #e6eef0",
          zIndex: "4",
        }}
      >
        {/* Decorative shapes */}
        <img
          className="d-none d-md-flex"
          src="https://res.cloudinary.com/davmkct9m/image/upload/v1769585945/Shape_1_lgnpkx.png"
          alt="shape 1"
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 0,
            right: 0,
            width: "460px",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />
        <img
          className="d-flex d-md-none"
          src="https://res.cloudinary.com/davmkct9m/image/upload/v1769586046/shapeFive_epassu.png"
          alt="shape 3"
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 0,
            right: 0,
            minWidth: "50%",
            minHeight: "10%",
            zIndex: 0,
          }}
        />
        <img
          className="d-flex d-md-none"
          src="https://res.cloudinary.com/davmkct9m/image/upload/v1769586101/Shape_six_tfd429.png"
          alt="shape 4"
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 800,
            minWidth: "50%",
            minHeight: " 10%",
            zIndex: 0,
          }}
        />

        <div
          className="container px-40 text-center"
          style={{ position: "relative", zIndex: 1, marginBottom: "70px" }}
        >
          <h2
            style={{}}
            className="fw-semibold tech-pad-nav Tech-heading text-black mb-2"
          >
            Where Our Work Meets Real Industries
          </h2>
          <p className="text-muted database-text mb-4">
            Every industry brings its own pressure points, habits, and unspoken
            rules. Our job is to understand those before we build anything.
          </p>
          <Link to="/contact-us/build-business">
            <motion.button
              type="button"
              className="data-button px-5 py-3 rounded-pill mb-5"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 30px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{
                backgroundColor: "#12869E",
                // scale: 1.02,
                boxShadow: "none",
              }}
              transition={{ duration: 0.18, ease: "easeOut" }}
              style={{ border: "none", color: "#fff", fontSize: "2rem" }}
            >
              Start Your Project
            </motion.button>
          </Link>

          {/* Industries Grid */}
          <div className="row gy-5 w-100 w-md-75 gx-6 w-75 mx-auto">
            {visibleIndustries.map((industry) => (
              <div key={industry.id} className="col-12 col-md-6 col-lg-4">
                <motion.div
                  style={{
                    backgroundColor: hovered === industry.id ? "#fff" : "",
                    height: "258px",
                  }}
                  className="h-150 w-full border p-3 rounded-4"
                  variants={parentVariants}
                  initial="rest"
                  whileHover="hover"
                  onMouseEnter={() => setHovered(industry.id)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <motion.div
                    className="d-flex px-4 py-4 flex-column align-items-center align-items-md-start text-center text-md-start"
                    variants={childVariants}
                  >
                    <motion.div
                      className="rounded-circle mb-3 d-flex align-items-center justify-content-center"
                      variants={childItemVariants}
                      style={{
                        width: "80px",
                        height: "80px",
                        backgroundColor: hovered === industry.id ? "#fff" : "",
                        transition: "background-color 0.3s",
                      }}
                    >
                      <motion.img
                        src={industry.icon}
                        alt={industry.title}
                        style={{
                          width: 68,
                          height: 68,
                          borderRadius: "50%",
                          position: "relative",
                          zIndex: 1,
                        }}
                        animate={{
                          x: hovered === industry.id ? -12 : 0,
                          opacity: hovered === industry.id ? 0 : 1,
                        }}
                        transition={{ duration: 0.12, ease: "easeOut" }}
                      />

                      <motion.img
                        src="https://i.ibb.co.com/6cvgH62h/Icon-14.png"
                        alt={industry.title}
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          position: "absolute",
                          zIndex: 4,
                          pointerEvents: "none",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                        initial={{ x: 10, opacity: 0 }}
                        animate={{
                          x: hovered === industry.id ? 0 : 24,
                          opacity: hovered === industry.id ? 1 : 0,
                        }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                      />
                    </motion.div>

                    <motion.h5
                      style={{ fontSize: "2.4rem" }}
                      className="text-black  fw-semibold mb-2"
                      variants={childItemVariants}
                    >
                      {industry.title}
                    </motion.h5>

                    <motion.div variants={childItemVariants}>
                      <p className="text-secondary fqa-text text-center text-md-start">
                        {industry.desc}
                      </p>
                    </motion.div>
                  </motion.div>
                </motion.div>
              </div>
            ))}
          </div>

          {/* Mobile See More */}
          {isMobile && industries.length > 7 && (
            <div className="text-center mt-3" ref={buttonRef}>
              <button
                className="btn fqa-text text-secondary"
                onClick={() => {
                  if (showAll) {
                    // collapsing
                    setShowAll(false);
                    setTimeout(() => {
                      buttonRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                    }, 300); // small delay for smooth transition
                  } else {
                    // expanding
                    setShowAll(true);
                  }
                }}
              >
                {showAll ? "See less" : "See more"}
                <span
                  style={{
                    width: "34px",
                    display: "inline-block",
                    transform: showAll ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <img style={{ width: "24px" }} src="https://res.cloudinary.com/davmkct9m/image/upload/v1769586203/Icon_Wrapper_g5wbuv.png" alt="" />
                </span>
              </button>
            </div>
          )}
        </div>
      </section>

      {/* =================== FAQ SECTION =================== */}
      <section
        id="f&q"
        className="faq-section mx-auto ps-md-5 pe-md-5 position-relative"
      >
        <img
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 206,
            right: 0,
            width: "310px",
            zIndex: 0,
            pointerEvents: "none",
          }}
          src="https://res.cloudinary.com/davmkct9m/image/upload/v1769586003/Shape_2_gesdy8.png"
          alt="decorative-shape"
          className="faq-shape d-none d-md-flex"
        />

        <div style={{ zIndex: 2 }} className="container position-relative">
          <div className="faq-box p-4 p-md-5 rounded-3">
            <div className="text-center mb-4 mb-md-5">
              <h2 className="fw-semibold display-6 Tech-heading">
                Questions People Ask Before Starting
              </h2>
              <p className="text-muted database-text mb-0">
                These are the conversations that usually happen on calls. We are
                sharing them upfront to save you time.
              </p>
            </div>

            {/* Accordion */}
            <div className="row">
              <div className="col-12 col-lg-10 mx-auto">
                <div className="accordion custom-accordion" id="faqAccordion">
                  {/* FAQ Items */}
                  {/* 01 */}
                  <div className="accordion-item faq-item">
                    <h2 className="accordion-header" id="faqHeadingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faqCollapseOne"
                        aria-expanded="true"
                        aria-controls="faqCollapseOne"
                      >
                        <span className="faq-num me-4 fw-semibold three">
                          01
                        </span>
                        <span className="faq-question fqa-heading">
                          Why do companies choose offshore software development
                          in Bangladesh with you?
                        </span>
                      </button>
                    </h2>
                    <div
                      id="faqCollapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="faqHeadingOne"
                      data-bs-parent="#faqAccordion"
                    >
                      <div
                        className="accordion-body fqa-text small text-muted px-3 px-md-5 ms-5"
                        style={{ textAlign: "justify", maxWidth: "85%" }}
                      >
                        In most cases, they turn to us after exhausting all
                        other possibilities. They seek experienced programmers,
                        fair prices, and fewer surprises along the way. We
                        provide help in the form of offshore software
                        development services in Bangladesh, where things appear
                        planned, predictable, and, what’s more, human.
                      </div>
                    </div>
                  </div>

                  {/* 02 */}
                  <div className="accordion-item faq-item">
                    <h2 className="accordion-header" id="faqHeadingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faqCollapseTwo"
                        aria-expanded="false"
                        aria-controls="faqCollapseTwo"
                      >
                        <span className="faq-num me-4 fw-semibold three">
                          02
                        </span>
                        <span className="faq-question fqa-heading">
                          How does communication actually work with your
                          offshore teams?
                        </span>
                      </button>
                    </h2>
                    <div
                      id="faqCollapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="faqHeadingTwo"
                      data-bs-parent="#faqAccordion"
                    >
                      <div
                        className="accordion-body fqa-text small text-muted px-3 px-md-5 ms-5"
                        style={{ textAlign: "justify", maxWidth: "85%" }}
                      >
                        It's simple. We provide good communication channels,
                        regular interactions, collaboration on common tools and
                        resources, and open and honest dialogue. The offshore
                        software development process should be as transparent as
                        a clear sky.
                      </div>
                    </div>
                  </div>

                  {/* 03 */}
                  <div className="accordion-item faq-item">
                    <h2 className="accordion-header" id="faqHeadingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faqCollapseThree"
                        aria-expanded="false"
                        aria-controls="faqCollapseThree"
                      >
                        <span className="faq-num me-4 fw-semibold three">
                          03
                        </span>
                        <span className="faq-question fqa-heading">
                          Do you only work with specific industries?
                        </span>
                      </button>
                    </h2>
                    <div
                      id="faqCollapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="faqHeadingThree"
                      data-bs-parent="#faqAccordion"
                    >
                      <div
                        className="accordion-body fqa-text small ms-5 text-muted px-3 px-md-5"
                        style={{ textAlign: "justify", maxWidth: "85%" }}
                      >
                        We focus on industries where we understand the pressure
                        points. Custom software development for healthcare,
                        fintech, e commerce, hospitality, education, and
                        services is where we do our best work.
                      </div>
                    </div>
                  </div>

                  {/* 04 */}
                  <div className="accordion-item faq-item">
                    <h2 className="accordion-header" id="faqHeadingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faqCollapseFour"
                        aria-expanded="false"
                        aria-controls="faqCollapseFour"
                      >
                        <span className="faq-num me-4 fw-semibold three">
                          04
                        </span>
                        <span className="faq-question fqa-heading">
                          Can we start small before committing long term?
                        </span>
                      </button>
                    </h2>
                    <div
                      id="faqCollapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="faqHeadingFour"
                      data-bs-parent="#faqAccordion"
                    >
                      <div
                        className="accordion-body fqa-text small text-muted px-3 px-md-5 ms-5"
                        style={{ textAlign: "justify", maxWidth: "85%" }}
                      >
                        Yes, and many of our clients do. We typically start with
                        a small development team or a discovery effort in the
                        offshore location, which grows as trust and
                        understanding are gained.
                      </div>
                    </div>
                  </div>

                  {/* 05 */}
                  <div className="accordion-item faq-item">
                    <h2 className="accordion-header" id="faqHeadingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faqCollapseFive"
                        aria-expanded="false"
                        aria-controls="faqCollapseFive"
                      >
                        <span className="faq-num me-4 fw-semibold three">
                          05
                        </span>
                        <span className="faq-question fqa-heading">
                          How do you handle quality in outsourced software
                          development?
                        </span>
                      </button>
                    </h2>
                    <div
                      id="faqCollapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="faqHeadingFive"
                      data-bs-parent="#faqAccordion"
                    >
                      <div
                        className="accordion-body small text-muted px-3 px-md-5 fqa-text ms-5"
                        style={{ textAlign: "justify", maxWidth: "85%" }}
                      >
                        Quality results from involvement, not promises. Our
                        process involves regular reviews of your work, ongoing
                        testing, and maintaining commitment long after project
                        completion. After all, long-term relationships are more
                        valuable than short-term successes.
                      </div>
                    </div>
                  </div>
                  {/* 06 */}
                  <div className="accordion-item faq-item">
                    <h2 className="accordion-header" id="faqHeadingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faqCollapseSix"
                        aria-expanded="false"
                        aria-controls="faqCollapseSix"
                      >
                        <span className="faq-num me-4 fw-semibold three">
                          06
                        </span>
                        <span className="faq-question fqa-heading">
                          How do you handle client confidentiality and data
                          protection?
                        </span>
                      </button>
                    </h2>
                    <div
                      id="faqCollapseSix"
                      className="accordion-collapse collapse"
                      aria-labelledby="faqHeadingSix"
                      data-bs-parent="#faqAccordion"
                    >
                      <div
                        className="accordion-body small text-muted px-3 px-md-5 fqa-text ms-5"
                        style={{ textAlign: "justify", maxWidth: "85%" }}
                      >
                        We take this very seriously. Most of our work involves
                        sensitive ideas, data, and internal systems, so
                        protecting that trust is non negotiable for us. We limit
                        access, follow clear internal rules, and stay careful at
                        every step, because once trust is broken, nothing else
                        matters.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom decorative shape (mobile) */}
        <img
          className="d-flex d-md-none"
          src="https://res.cloudinary.com/davmkct9m/image/upload/v1769586144/ShapeSeven_kbs2nm.png"
          alt="shape 5"
          style={{
            opacity: 0.2,
            position: "absolute",
            left: 220,
            right: 0,
            bottom: 4,
            minWidth: "50%",
            minHeight: "15%",
            zIndex: 0,
          }}
        />
      </section>
    </div>
  );
};

export default IndustriesWeWork;
